'use strict';

import { IBeaconSensitivityDto_Props } from './BeaconSensitivityDto.if';
import { IModelSource } from '../interface/db';
import DBUtil from '../private/db.util';

export interface IBeaconSensitivityDto_Linkables {}

/** 
 * @description all custom properties for
   BeaconSensitivityDto & methods to link against other entities
*/
function linkables(model: Partial<IBeaconSensitivityDto_Props>): IBeaconSensitivityDto_Linkables {
    return {};
}

export default linkables;
